import { Injectable } from '@angular/core';
import { PushNotificationService } from 'src/app/system/utility/push-notification.service';
import { PerformanceService } from 'src/app/system/utility/performance.service';
import { WebSocketService } from 'src/app/system/utility/websocket.service';
import { SessionService } from '../session/session.service';
import { CrashlyticsService } from 'src/app/system/utility/crashlytics.service';
import { KeyboardService } from 'src/app/system/utility/keyboard.service';
import { NavigationService } from 'src/app/system/utility/navigation.service';
import { AppAuthenticatorService } from '../../components/app-authenticator/app-authenticator.service';

/**
 * This is the Application Service that store the initialization of the application
 */
@Injectable({
    providedIn: 'root'
})
export class ApplicationService {

    /**
     * Application Services that on the information of External Settings
     */

    constructor(
        private srvPushNotification: PushNotificationService,
        private srvPerformance: PerformanceService,
        private srvWebSocket: WebSocketService,
        private srvSession: SessionService,
        private srvKeyboard: KeyboardService,
        private srvCrashlytics: CrashlyticsService,
        private srvNavigation: NavigationService,
        private srvAppAuthenticator: AppAuthenticatorService,
    ) { }

    public init(): void {

        // Initialize Performance Metrics 
        this.srvPerformance.init();

        // Subscribe App Authenticator before Capacitor push listeners attach.
        // On cold start, pushNotificationActionPerformed is retained and fires as soon as
        // the first listener is registered inside PushNotificationService.init().
        this.srvAppAuthenticator.init();

        // Initialize Push Notification Service
        this.srvPushNotification.init();

        // Initialize Keyboard Service
        this.srvKeyboard.init();

        // Initialize WebSocket Service
        this.srvWebSocket.init();

        // Initalize Session Service
        this.srvSession.init();

        // Initialize Navigation Service
        this.srvNavigation.init();

        // Initialize Crashlytics Service
        this.srvCrashlytics.init();
    }
}